import Drawable from '../entities/Drawable.js';
import StatusBadge from './StatusBadge.js';
import Sprite from './Sprite.js';
import { imageStore } from '../images.js';
import { c } from '../setup.js';
import PixelText from './PixelText.js';

export default class FoePokemonBattleInfoBox extends Drawable {
    constructor({ pokemon, sprites, position = { x: 0, y: 0 }, visible = true, caught = true }) {
        super();
        this.pokemon = pokemon;
        this.sprites = sprites;
        this.position = position;
        this.visible = visible;
        this.sprites.statusBadge = new StatusBadge({
            position: { x: this.position.x + 8, y: this.position.y + 12 },
            status: this.pokemon.status1 ? this.pokemon.status1.id : 'blank',
        });

        this.caught = caught;
        this.sprites.caughtIcon = new Sprite({
            position: { x: this.position.x + 8, y: this.position.y + 12 },
            image: imageStore.get('img/pokemon_caught.png'),
            moving: false,
            frames: { max: 1, val: 0 },
            visible: this.caught,
        });

        this.pokemonName = new PixelText({
            text: '',
            position: {
                x: this.position.x + 20,
                y: this.position.y + 20,
            },
            color: 'black',
        });
        this.pokemonLevel = new PixelText({
            text: '',
            position: {
                x: this.position.x + 94,
                y: this.position.y + 20,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.pokemonGender = new PixelText({
            text: '',
            position: {
                x: this.pokemonLevel.position.x - 6,
                y: this.position.y + 20,
            },
            color: 'black',
        });
        this.pokemonHP = new PixelText({
            text: '',
            position: {
                x: this.position.x + 100,
                y: this.position.y + 38,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.showHpAsPercentage = false;
    }

    draw() {
        if (!this.visible) {
            return;
        }
        this.sprites.caughtIcon.visible = this.caught;
        this.sprites.caughtIcon.position = {
            x: this.position.x + 18,
            y: this.position.y + 31,
        };

        if (this.pokemon.status1) {
            this.sprites.battleSceneFoeInfoNoHPLabel.position = this.position;
            this.sprites.battleSceneFoeInfoNoHPLabel.draw();
            this.sprites.statusBadge.position.x = this.position.x + 22;
            this.sprites.statusBadge.position.y = this.position.y + 30;
            this.sprites.statusBadge.status = this.pokemon.status1.id;
            this.sprites.statusBadge.draw();
        } else {
            this.sprites.battleSceneFoeInfo.position = this.position;
            this.sprites.battleSceneFoeInfo.draw();
        }
        this.sprites.caughtIcon.draw();
        const barShouldBeRed = this.pokemon.stats.hp < this.pokemon.stats.maxHp * 0.2;
        const barShouldBeYellow = this.pokemon.stats.hp < this.pokemon.stats.maxHp * 0.5;
        c.fillStyle = Drawable.blackBarColor;
        c.fillRect(this.position.x + 52, this.position.y + 33, 48, 3);
        // Foe Health Bar
        c.fillStyle = barShouldBeRed
            ? Drawable.redBarColor
            : barShouldBeYellow
            ? Drawable.yellowBarColor
            : Drawable.greenBarColor;
        c.fillRect(
            this.position.x + 52,
            this.position.y + 33,
            Math.ceil(48 * (this.pokemon.stats.hp / this.pokemon.stats.maxHp)),
            3
        );
        c.fillStyle = barShouldBeRed
            ? Drawable.redBarShadow
            : barShouldBeYellow
            ? Drawable.yellowBarShadow
            : Drawable.greenBarShadow;
        c.fillRect(
            this.position.x + 52,
            this.position.y + 33,
            Math.ceil(48 * (this.pokemon.stats.hp / this.pokemon.stats.maxHp)),
            1
        );

        // Gender symbol setup
        let genderString = '';
        let genderColor = null;

        if (this.pokemon.gender === 'Female') {
            genderString = '\u2640 ';
            genderColor = 'red';
        }
        if (this.pokemon.gender === 'Male') {
            genderString = '\u2642 ';
            genderColor = 'blue';
        }

        const levelText = `Lv${this.pokemon.level}`;

        // Draw foe data
        // c.font = '8px PokeFont';
        // c.fillStyle = 'rgba(80, 60, 60, 0.3)';
        // c.fillText(this.pokemon.name, this.position.x + 20 + 1, 28 + 1);
        // c.fillStyle = 'rgba(60, 60, 60, 1)';
        // c.fillText(this.pokemon.name, this.position.x + 20, 28);
        this.pokemonName.text = this.pokemon.name;
        this.pokemonName.position.x = this.position.x + 18;
        this.pokemonLevel.text = levelText;
        this.pokemonLevel.position.x = this.position.x + 100;
        this.pokemonGender.text = genderString;
        this.pokemonGender.position.x =
            this.pokemonLevel.position.x - this.pokemonLevel.measureTextWidth(this.pokemonLevel.text) - 6;
        if (genderString) {
            this.pokemonGender.setColor(genderColor);
        }
        this.pokemonName.draw();
        this.pokemonLevel.draw();
        this.pokemonGender.draw();

        // c.textAlign = 'right';

        // // Draw level text shadow
        // c.fillStyle = 'rgba(80, 60, 60, 0.3)';
        // c.fillText(levelText, this.position.x + 100 + 1, 28 + 1);

        // // Draw level text
        // c.fillStyle = 'rgba(60, 60, 60, 1)';
        // c.fillText(levelText, this.position.x + 100, 28);

        // // Draw gender symbol with shadow if it exists
        // if (genderString) {
        //     const levelWidth = c.measureText(levelText).width;

        //     // Draw gender symbol shadow
        //     c.fillStyle = genderShadowColor;
        //     c.fillText(genderString.trim(), this.position.x + 100 + 1 - levelWidth, 28 + 1);

        //     // Draw gender symbol in color
        //     c.fillStyle = genderColor;
        //     c.fillText(genderString.trim(), this.position.x + 100 - levelWidth, 28);
        // }

        // c.textAlign = 'left';
    }
}
